'use client';

import { useEffect } from 'react';
import { setPostHogFeatureFlagValues } from '@/lib/analytics/client';

export function PostHogFeatureFlagValues({ values }: { values: Record<string, boolean> }) {
	useEffect(() => {
		setPostHogFeatureFlagValues(values);
	}, [values]);

	return null;
}
